export enum API_ERROR_ACTION {
  NO_ACTION = 'no_action',
  REDIRECT = 'redirect',
  REDIRECT_TO_SUPERADMIN = 'redirect_to_superadmin',
}

export enum API_FORBIDDEN_REASON {
  ACCESS_DENIED = 'access_denied',
  INSUFFICIENT_PERMISSIONS = 'insufficient_permissions',
}

export type ApiForbiddenErrorBody = {
  message?: string;
  reason?: string;
  action?: string;
};
